export const CHANGE_THEME_MODE = 'CHANGE_THEME_MODE';
export const SHOW_FULL_SCREEN_LOADER = 'SHOW_FULL_SCREEN_LOADER';
